export default (state: any) => {
  const setUser = (payload: any) => {
    state.user = payload
  }

  const signIn = () => {
    state.auth = true
  }

  const signOut = () => {
    state.auth = false
  }

  return {
    setUser,
    signIn,
    signOut,
  }
}
